import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { BooleanIconText } from 'components/core-ui/BooleanIconText'
import { ApproveFileWhite, DeleteFileRed } from 'icons'
import { MultivalueCell } from '../../core-ui/MultivalueCell'
import { AccompanyingNoteTableItem } from '../interfaces'

export const getColumns = () => [
  {
    title: 'Nr. Aviz',
    field: 'wanNumber',
    align: 'left',
    type: 'string',
    width: '80px'
  },
  {
    title: 'Locatie',
    field: 'storeName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data',
    field: 'creationDate',
    align: 'left',
    type: 'string',
    width: '80px'
  },
  {
    title: 'Categorii',
    field: 'wasteCategories',
    align: 'left',
    type: 'string',
    collapsible: true,
    // width: '300px',
    disableSorting: true,
    render: (row: AccompanyingNoteTableItem) => (
      <MultivalueCell value={row.wasteCategories} field="name" size={1} />
    )
  },
  {
    title: 'Destinatar',
    field: 'companyName',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Anexe transport',
    field: 'wasteReports',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    render: (row: AccompanyingNoteTableItem) => (
      <MultivalueCell value={row.wasteReports} field="report" size={1} />
    )
  },
  {
    title: 'Greutatea totala (kg)',
    field: 'measuredWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '80px',
    disableSorting: true
  },
  {
    title: 'Doc',
    field: 'documentNo',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '70px',
    render: (row: AccompanyingNoteTableItem) => (
      <BooleanIconText
        value={row.documentNo}
        successIcon={<ApproveFileWhite />}
        failureIcon={<DeleteFileRed />}
        isSuccess={row.documentNo > 0}
        isFailure={!row.documentNo}
      />
    )
  }
]

export const getFilters = (companyOptions: AutocompleteOption[]) => [
  {
    name: 'startDate',
    value: null,
    filter: <DatePicker label="Data inceput" variant="outlined" value={null} onChange={() => {}} />,
    type: 'date',
    label: 'Data inceput'
  },
  {
    name: 'endDate',
    value: null,
    filter: <DatePicker label="Data sfarsit" variant="outlined" value={null} onChange={() => {}} />,
    type: 'date',
    label: 'Data sfarsit'
  },
  {
    name: 'companyId',
    value: '',
    filter: <Autocomplete variant="outlined" label="Destinatar" options={companyOptions || []} />,
    type: 'autocomplete',
    label: 'Destinatar'
  },
  {
    name: 'wanNumber',
    label: 'Nr. Aviz',
    type: 'text',
    filter: <Input type="text" name="pvNumber" label="Nr. Aviz" variant="outlined" value="" />
  }
]
